import { ReactNode, useState } from 'react'
import style from './style.module.scss'
import dotIcon from 'src/assets/img/icons/dots.svg'

interface Props {
  children: ReactNode
}

const MoreActionsList = ({ children }: Props) => {
  const [open, setOpen] = useState(false)

  return (
    <>
      <div className={style.actions_wrapper}>
        <button className={style.more_actions_btn} onClick={() => setOpen(!open)}>
          <img className={style.dots} src={dotIcon} alt="more actions" />
        </button>
        {open && <ul className={style.more_actions}>{children}</ul>}
      </div>
    </>
  )
}

export default MoreActionsList
